import Vue from 'vue'
import httpManager from '../../util/common'
import * as d3 from 'd3'
import {reportYear} from "../../util/util";

let vm = {
  name: 'ESGIndustryGradeBarChart',
  delimiters: ['{', '}'],
  props: {
    oaid:String,
  },
  data: () => {
    return {
      data: null,
      year: null,
      industry:"",
      industryName:"",
      report_year_list: [],
      divloading: false
    }
  },
  methods: {
    generate_report_year_list () {
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_year_list = result.report_list
        self.year=self.report_year_list[0]
        self.getGics()
      })
    },
    getGics(){
      let self = this
      self.divloading = true
      let pathVars = new Map()
      pathVars.set("oaid", self.oaid)
      httpManager("gics_oaid",null,null,null,pathVars)
        .then(response => {
          if(response.data){
            self.industry = response.data.data
            reportYear.gics().then(result => {
              self.industryName =result[self.industry][this.$i18n.locale]
            })
            self.getESGData()
            self.divloading = false
          }
        })
        .catch(error => {
          self.divloading = false
          console.log(error)
        })

    },
    getESGData() {
      let year = this.year
      let params = new Map()
      params.set("year", year)
      params.set("industry", this.industry)
      let self = this
      httpManager("esg_entity_statistics", params)
        .then(response => {
          if(response.data.data){
            self.data = response.data.data.data
            self.drawChart()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    drawChart() {
      let self = this
      let gradeNum=['AAA','AA','A','BBB','BB','B','CCC','CC','C'].reverse()
      let dataDict = self.data.reduce((total, x)=> {total[x.name]=x.count;return total}, {})
      let data = Object.assign(gradeNum.map(x => ({'count':dataDict.hasOwnProperty(x)?dataDict[x]:0,'name':x})), {y: "$ Close"})
      d3.select("#esg_industry_grade_bar_chart").select('*').remove()
      let height = 171
      let width = 416
      let svg = d3.select("#esg_industry_grade_bar_chart").append("svg").attr("viewBox", [0, 0, width, height])
      let margin = ({top: 20, right: 17, bottom: 41, left: 52})
      let barHeight = 25

      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x).tickFormat(i => data[i].name))
      let yAxis = g => g
        .attr("transform", `translate(${margin.left},0)`)
        .call(g => g.select(".domain").remove())
        .call(d3.axisLeft(y).ticks(width / 80, data.format))
      let x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([margin.left, width - margin.right])
      .padding(0.1)
      let y = d3.scaleLinear()
      .domain([0, d3.max(data, d => d.count)])
      .range([height - margin.bottom, margin.top])
      let format = y.tickFormat(20, data.format)
      svg.append("g")
        .attr("fill", "#c92525")
        .selectAll("rect")
        .data(data)
        .join("rect")
        .attr("y", d => y(d.count))
        .attr("x", (d, i) => x(i) + 9)
        .attr("width", 15)
        .attr("height", d => y(0) - y(d.count));
      svg.append("g")
        .attr("fill", "black")
        .attr("text-anchor", "center")
        .attr("font-family", "PingFang SC")
        .attr("font-size", 12)
        .selectAll("text")
        .data(data)
        .join("text")
        .attr("y", d =>y(d.count))
        .attr("x", (d, i) => {
          if (d.count < 10) return x(i) + x.bandwidth() / 2 - 4
          if (d.count < 100 && d.count >= 10) return x(i) + x.bandwidth() / 2 - 8
          return x(i) + x.bandwidth() / 2 - 11.5
        })
        .attr("dy", -2)
        .attr("dx", 0)
        .text(d => parseInt(format(d.count)))
      svg.append("g")
        .call(xAxis);
      svg.append("g")
        .call(yAxis);
      svg.node();
    },
    // post路由跳转，使用路由名称
    turnToPage(routeName) {
      let params = { industry: this.industry }
      this.$router.push({name: routeName, params})
    }

  },
  mounted() {
    this.generate_report_year_list()
  },
  watch:{
    year:function(){
      this.getESGData()
    },
    "$i18n.locale"() {
      reportYear.gics().then(result => {
        this.industryName =result[this.industry][this.$i18n.locale]
      })
    }
  }
}
Vue.component("esg-industry-rating-bar-chart", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_industry_rating_bar_chart.js